/* eslint-disable */
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
var Model = BaseProjection.extend({
  defaults: {
    seed: []
  },
  update: function () {
    this.trigger('update:beginning');
    var value = this.get('seed');
    this.data.set({
      value: value,
      count: value.length
    });
    this.trigger('update:finished');
  }
});
export default Model;

